import { isEqual, keyBy } from "lodash-es";
// 如果有null值推出来的schema
// eslint-disable-next-line complexity
export function isEqualForDataSchema(value, other, excludeIds = []) {
  if (value.type !== 'any' && other.type !== 'any' && value.type !== other.type) {
    return false;
  }
  if (value.type === 'object' && value.fields && other.fields) {
    const valueFields = getFields(value.fields, excludeIds);
    const otherFields = getFields(other.fields, excludeIds);
    const lengthEqual = valueFields.length === otherFields.length;
    if (!lengthEqual) {
      return false;
    }
    // 校验id type是否有差异  id有空的比较难处理，todo
    const valueArray = getIdTypeArray(valueFields);
    const othersArray = getIdTypeArray(otherFields);
    if (!isEqual(valueArray, othersArray)) {
      return false;
    }
    // id 和type都一致 递归进行type='object'|'array‘的校验 不考虑字段顺序
    const valueMap = keyBy(valueFields, 'id');
    const otherMap = keyBy(otherFields, 'id');
    return valueArray.every(({
      id
    }) => {
      const index = String(id);
      return isEqualForDataSchema(valueMap[index], otherMap[index], excludeIds);
    });
  }
  if (value.type === 'array' && value.items && other.items) {
    return isEqualForDataSchema(value.items, other.items, excludeIds);
  }
  return true;
}
function getIdTypeArray(schemas) {
  return schemas.map(item => ({
    id: item.id,
    type: item.type
  }));
}
function getFields(fields, excludeIds) {
  return fields.filter(item => !excludeIds.includes(String(item.id)));
}
//# sourceMappingURL=isEqualDataSchema.js.map
